import { LangEnum } from './locales'
import { DEFAULT_REGION_CODE } from './regions'

import { RegionIdMap, RegionCodeMap } from '@/types/region'

export function getCountryCodeByRegionId(regionId: number) {
  switch (regionId) {
    case RegionIdMap.EATIGO_KUALA_LUMPUR:
      return RegionCodeMap.MY
    case RegionIdMap.EATIGO_LUZON:
    case RegionIdMap.EATIGO_VISAYAS:
    case RegionIdMap.EATIGO_MINDANAO:
      return RegionCodeMap.PH
    case RegionIdMap.EATIGO_SINGAPORE:
      return RegionCodeMap.SG
    case RegionIdMap.EATIGO_BANGKOK:
    case RegionIdMap.EATIGO_CHONBURI:
    case RegionIdMap.EATIGO_CHIANG_MAI:
    case RegionIdMap.EATIGO_PHUKET:
    case RegionIdMap.EATIGO_SONGKLA:
      return RegionCodeMap.TH
    case RegionIdMap.EATIGO_HONG_KONG:
      return RegionCodeMap.HK
    case RegionIdMap.EATIGO_TAIPEI:
      return RegionCodeMap.TW
    default:
      return DEFAULT_REGION_CODE
  }
}

function genRegionMap(originMap: Record<string, string>) {
  return new Proxy(originMap, {
    get(target, regionId) {
      const countryCode = getCountryCodeByRegionId(Number(regionId))

      return Reflect.get(target, countryCode)
    },
  })
}

// footer link doc: https://docs.google.com/spreadsheets/d/1mEzU_GmNDCQTZrAh71KCDOVSkJEWbywXFa3wJ3T6OHs/edit?gid=0#gid=0
export const facebookLangMap = (() => {
  const PREFIX = 'https://www.facebook.com/eatigo.'

  return genRegionMap({
    [RegionCodeMap.TH]: `${PREFIX}thailand`,
    [RegionCodeMap.SG]: `${PREFIX}singapore`,
    [RegionCodeMap.HK]: `${PREFIX}hongkong`,
    [RegionCodeMap.PH]: `${PREFIX}ph`,
    [RegionCodeMap.MY]: `${PREFIX}malaysia`,
    [RegionCodeMap.TW]: `${PREFIX}taiwan`,
  })
})()

export const instagramLangMap = (() => {
  const PREFIX = 'https://www.instagram.com/eatigo_'

  return genRegionMap({
    [RegionCodeMap.TH]: `${PREFIX}thailand`,
    [RegionCodeMap.SG]: `${PREFIX}sg`,
    [RegionCodeMap.HK]: `${PREFIX}hk`,
    [RegionCodeMap.PH]: `${PREFIX}ph`,
    [RegionCodeMap.MY]: `${PREFIX}my`,
    [RegionCodeMap.TW]: `${PREFIX}tw`,
  })
})()

export const YOUTUBE_LINK = 'https://www.youtube.com/eatigo'
export const CAREERS_LINK = 'https://eatigo.zohorecruit.com/jobs/Careers'

export function getBlogLangMap(lang: string) {
  const PREFIX = 'https://blog.eatigo.com/'

  return genRegionMap({
    [RegionCodeMap.TH]: PREFIX + (lang === LangEnum.ENG ? 'thailand-en' : 'thailand-th'),
    [RegionCodeMap.SG]: `${PREFIX}singapore`,
    [RegionCodeMap.HK]: PREFIX + (lang === LangEnum.ENG ? 'hong-kong-en' : 'hong-kong-zh'),
    [RegionCodeMap.PH]: `${PREFIX}philippines`,
    [RegionCodeMap.MY]: `${PREFIX}malaysia`,
    [RegionCodeMap.TW]: `${PREFIX}taiwan-zh`,
  })
}

export function getFaqLinkUrl(lang: LangEnum | string) {
  const template = (langStr: TemplateStringsArray) => `https://help.eatigo.com/hc/${langStr[0]}`

  const langMap: Record<LangEnum, string> = {
    [LangEnum.ENG]: template`en-us`,
    [LangEnum.CN]: template`en-us`,
    [LangEnum.THAI]: template`th`,
    [LangEnum.TW]: template`zh-tw`,
    [LangEnum.HK]: template`zh-tw`,
  }

  return langMap[lang as LangEnum] || langMap[LangEnum.ENG]
}

export function getJoinUsLinkUrl(lang: LangEnum | string) {
  const template = (langStr: TemplateStringsArray) => `https://forms.zohopublic.com/eatigointernationalpteltd/form/${langStr[0]}`

  const langMap: Record<LangEnum, string> = {
    [LangEnum.ENG]: template`JoinUs/formperma/VHkdH1-JugsZpxiXQUcA951Rlx2QOzkt2SJA_Z4wryI`,
    [LangEnum.CN]: template`Untitled/formperma/L5LYqZfSqTGPzr0VSu7iNKBXjcDCKl7Twb8LErRQSkE`,
    [LangEnum.THAI]: template`JoinUsTH/formperma/HFLxqcJr4vFpg1DD-8zMOqTzMnVvFo_vPAC1uV33lX0`,
    [LangEnum.TW]: template`Untitled1/formperma/BG-OP26MAoJVLhlIWypp402Mm8HkSEqsvCTrlDIv2gY`,
    [LangEnum.HK]: template`Untitled1/formperma/BG-OP26MAoJVLhlIWypp402Mm8HkSEqsvCTrlDIv2gY`, // Zoho Knowledge Base only has zh-tw
  }
  return langMap[lang as LangEnum] || langMap[LangEnum.ENG]
}
